import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgQuestionMarkIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 8,
		cy: 8,
		r: 8,
		fill: "#454545"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M7.248 10.444H7.992L8.112 9.196C9.528 8.992 10.692 8.236 10.692 6.676V6.64C10.692 5.176 9.564 4.156 7.86 4.156C6.516 4.156 5.616 4.732 4.908 5.584L5.628 6.316C6.252 5.596 6.948 5.2 7.824 5.2C8.88 5.2 9.528 5.836 9.528 6.676V6.7C9.528 7.684 8.712 8.308 7.092 8.356L7.032 8.416L7.248 10.444ZM6.96 13H8.256V11.56H6.96V13Z",
		fill: "white"
	})]
});
export default SvgQuestionMarkIcon;
